import { useMemo } from "react"

import CustomError from "models/CustomError"
import ValidationService from "services/ValidationService"
import { ITranslations } from "@/types"

export interface ITranslationsValidation {
    [isoCode: string]: CustomError
}

export default function useTranslationsValidation(translations: ITranslations, mandatoryTranslationIsoCodes: string[] = []): ITranslationsValidation {
    const validationErrors = useMemo((): { [isoCode: string]: CustomError } => {
        return validateTranslations(translations, mandatoryTranslationIsoCodes)
    }, [mandatoryTranslationIsoCodes, translations])

    return validationErrors
}

export function validateTranslations(translations: ITranslations, mandatoryTranslationIsoCodes: string[] = []): ITranslationsValidation {
    if (!mandatoryTranslationIsoCodes.length) return {}
    return ValidationService.validateMultiple(mandatoryTranslationIsoCodes.map(isoCode => ([
        isoCode,
        { required: true },
        translations[isoCode]?.trim() || "",
    ])))
}
